import { useState, useEffect } from 'react';
import { processMediaItems } from '../utils/mediaProcessor';
import type { MediaItem } from '../types/animatronic';

export function useMediaLoader(mediaItems: MediaItem[]) {
  const [validMedia, setValidMedia] = useState<MediaItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadMedia = async () => {
      try {
        setIsLoading(true);
        const processed = processMediaItems(mediaItems);
        
        if (isMounted) {
          setValidMedia(processed);
          setError(null);
        }
      } catch (err) {
        console.error('Error loading media:', err);
        if (isMounted) {
          setError(err instanceof Error ? err.message : 'Failed to load media');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadMedia();

    return () => {
      isMounted = false;
    };
  }, [mediaItems]);

  return { validMedia, isLoading, error };
}